import React, { useState } from "react";
import ic_cubix_ribbon_logo from "../img/ic_cubix_ribbon_label.png";
import ic_blue_cube from "../img/ic_blue_cube.png";
import ic_search from "../img/ic_search.png";
import "../css/CustomerDetailsPage.css";
import Header from "./Header";
import axios from "axios";

function CustomerDetailsPage() {

    const [showLoadingStateViewLog, setShowLoadingStateViewLog] = useState(false);
    let timeInterval = null;
    const [selectedItemIndex, setSelectedItemIndex] = useState(null);
    const [showHideSearchListBox, setShowHideSearchListBox] = useState(false);
    const [arrayOfSearchResults, setArrayOfSearchResults] = useState();

    const handleInput = (e) => {

        clearInterval(timeInterval);

        timeInterval = setTimeout(() => {
            if (e.target.value.length > 0) {

                console.log(" searchtext changed is", e.target.value);
                if (timeInterval) {
                    console.log("timer is not null we are clearing it")
                    clearInterval(timeInterval);
                }
                setShowHideSearchListBox(true);
                callApi(e.target.value);

            } else {
                setShowHideSearchListBox(false);
            }
        }, 500)
    }


    const showLoadingForViewLog = () => {
        setShowLoadingStateViewLog(prev => !prev);
    }

    const callApi = (searchingText) => {

        showLoadingForViewLog();

        let sales_man_name = localStorage.getItem("cubix_order_taking_sales_man");
        let sales_man_group = localStorage.getItem("cubix_order_taking_logged_in_person_group");

        if (sales_man_group.trim() == "EXECUTIVES") {
            axios.get(`${process.env.REACT_APP_BASE_URL}/SearchCust_Sales/customer/${searchingText}/${sales_man_name}`).then((res) => {
                showLoadingForViewLog();
                console.log(" res is executives ", res);
                setArrayOfSearchResults(res.data)
            }).catch(err => { console.log("error is ", err); showLoadingForViewLog(); })
        } else {
            axios.get(`${process.env.REACT_APP_BASE_URL}/Search_Customer/Cust/${searchingText}`).then((res) => {
                console.log(" res is not executive", res);
                setArrayOfSearchResults(res.data.jsont)
                showLoadingForViewLog();
            }).catch(err => { console.log("error is ", err); showLoadingForViewLog(); })
        }
    }


    const clickedItemFromSearchList = (ind) => {
        console.log("clicked on ", ind);
        setSelectedItemIndex(ind)
        setShowHideSearchListBox(false);
    }


    return (
        <div className="CustomerDetailsPage-root-container">

            <div className="CustomerDetailsPage-layer-1">
                <img src={ic_blue_cube} />
            </div>

            <div className="CustomerDetailsPage-layer-2 ">
                <Header />

                <h4>Customer Details</h4>
                <div className="CustomerDetailsPage-layer-2-underline"></div>

                <div className="CustomerDetailsPage-search-box-and-list-container">
                    <div className="CustomerDetailsPage-search-box">
                        <div>
                            <img src={ic_search} />
                        </div>
                        <input autoComplete="off" className="CustomerDetailsPage-search-input" type="text" placeholder="Enter customer name" name="searchText" onChange={(e) => handleInput(e)} />
                    </div>

                    {showHideSearchListBox &&
                        <div className="CustomerDetailsPage_SearchResultListContainer">
                            {/* { arrayOfSearchResults != null ? 
                                arrayOfSearchResults.length > 0 ? 
                                    arrayOfSearchResults.map((item, index)=>{
                                    return (<div key={item.account} id={item.account} className="CheckStockPage_SearchResultListContainer_single_list_item" onClick={()=>clickedItemFromSearchList(index)} ><span id={item.account}>{item.Custname}</span></div>)
                                    }) 
                                    : null 
                            : null} */}

                            <div>
                                {showLoadingStateViewLog ? <p className="loading-table-CustomerDetailPage">Loading</p> : null}
                            </div>
                            <table className="CheckStockPage_SearchResultListContainer-table">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Account Number</th>
                                        <th>Balance</th>
                                        {/* currently no status is received from API, when we receive
                                                    the value put it in this column */}
                                        {/* <th>Status</th> */}
                                    </tr>
                                </thead>
                                <tbody>

                                    {arrayOfSearchResults != null ?
                                        arrayOfSearchResults.length > 0 ?
                                            arrayOfSearchResults.map((item, index) => {
                                                return (<tr key={item.Code} id={item.Code} className="CheckStockPage_SearchResultListContainer_single_list_item" onClick={() => clickedItemFromSearchList(index)} >
                                                    <td>
                                                        <div>
                                                            {item.Custname}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div>
                                                            {item.account}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div>
                                                            {(item.debit - item.credit).toLocaleString('en-US', { maximumFractionDigits: 2 })}
                                                        </div>
                                                    </td>

                                                    {/* currently no status is received from API, when we receive
                                                    the value put it in this column */}


                                                    {/* <td>
                                                        <div>
                                                            {item.status}
                                                        </div>
                                                    </td> */}

                                                </tr>)
                                            })
                                            : null
                                        : null}

                                </tbody>
                            </table>
                        </div>
                    }
                </div>

                {
                    arrayOfSearchResults ?
                        selectedItemIndex !== null ?
                            arrayOfSearchResults[selectedItemIndex] != null ?
                                <div className="CustomerDetailsPage_details_card">
                                    <label className="mt-2">Customer name</label>
                                    <div className="mt-1"><span>{arrayOfSearchResults[selectedItemIndex].Custname}</span></div>
                                    <label className="mt-2">Address</label>
                                    <div className="mt-1"><span>{arrayOfSearchResults[selectedItemIndex].address1}</span></div>
                                    <div className="mt-1"><span>{arrayOfSearchResults[selectedItemIndex].address2}</span></div>
                                    <div className="mt-1"><span>{arrayOfSearchResults[selectedItemIndex].address3}</span></div>
                                    <label className="mt-2">Phone</label>
                                    <div className="mt-1"><span>{arrayOfSearchResults[selectedItemIndex].phone}</span></div>
                                    <label className="mt-3">Open bal</label>
                                    <div className="mt-1"><span>{arrayOfSearchResults[selectedItemIndex].openbal}</span></div>
                                    <label className="mt-3">Balance</label>
                                    <div className="mt-1"><span>{(arrayOfSearchResults[selectedItemIndex].debit - arrayOfSearchResults[selectedItemIndex].credit).toLocaleString('en-US', { maximumFractionDigits: 2 })} </span></div>
                                    <label className="mt-3">Message</label>
                                    <div className="mt-1"><span>{arrayOfSearchResults[selectedItemIndex].msg}</span></div>
                                </div>
                                :
                                null
                            :
                            null

                        :
                        null
                }

            </div>

        </div>
    )

}

export default CustomerDetailsPage;